import { computed } from 'vue'

import { Role } from '@/enums/roles.ts'
import i18n from '@/libs/i18n'
import { useAppStore } from '@/stores/app.ts'
import type { DropdownType } from '@/types/Common.ts'

const { t } = i18n.global

export const Roles = computed((): DropdownType[] => {
    return [
        { name: t('role.admin'), value: Role.ADMIN },
        { name: t('role.user'), value: Role.USER }
    ]
})

export const getRole = (value: string): DropdownType => {
    const index = Roles.value.findIndex(x => x.value === value)
    return index > -1 && Roles.value[index] ? Roles.value[index] : { name: '', value: '' }
}

export const hasRoles = (...roles: string[] | Role[]): boolean => {
    const userRoles = useAppStore().getUserData().roles

    for (const role of roles) {
        if (userRoles.includes(role)) return true
    }

    return false
}

